// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1nhPo","title":"Info_title__1cVRv","selects":"Info_selects__140A3","requiredAsterisk":"Info_requiredAsterisk__39q6s"};